import { all, put, select, takeLatest } from 'redux-saga/effects';
import { BlogsActionTypes } from './blogs-actions';
import { AlertActionType } from '@store/alert/alert-action';
import { blogsStore } from './blogs-store';
import postItemsApi from '@api/posts/post-items';

function* getBlogsExtendedListWatcher() {
  const { currentPage, blogList, searchValue, typeId } = yield select(blogsStore);

  try {
    const response: { data: Array<object>, last_page: number, current_page: number } = yield postItemsApi({
      page: currentPage,
      limit: 10,
      typeId: typeId,
      searchQuery: searchValue,
      cache: 'no-cache',
    });

    yield put({
      type: BlogsActionTypes.SET_EXTENDED_BLOGS,
      data: {
        blogList: [...blogList, ...response?.data],
        lastPage: response?.last_page,
        currentPage: response?.current_page,
      },
    });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}

function* loadBlogListDataWatcher() {
  try {
    const { searchValue } = yield select(blogsStore);

    const response: { data: Array<object> } = yield postItemsApi({ page: 1, limit: 10, searchQuery: searchValue, cache: 'no-cache' });

    yield put({
      type: BlogsActionTypes.SET_SEARCH_BLOG_LIST,
      data: response?.data,
    });
  } catch (error : any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}
function* blogsMiddleware() {
  yield all([
    takeLatest(BlogsActionTypes.GET_EXTENDED_BLOGS, getBlogsExtendedListWatcher),
    takeLatest(BlogsActionTypes.GET_SEARCH_BLOG_LIST, loadBlogListDataWatcher),
  ]);
}

export default blogsMiddleware;
